import React from 'react';
import {RacesTabs} from "./RacesTabs";
import {BrowserRouter, Route} from "react-router-dom";
import {createMuiTheme,MuiThemeProvider} from "@material-ui/core/styles";
import RaceMap from "./RaceMap";


const App = () => {
    const darkTheme = createMuiTheme(({
        palette:{
            type: "light",
            primary: {
                main: '#052d72',
            },
            secondary: {
                main: '#FFCA08',
            },
        }
    }))
    return  <MuiThemeProvider theme={darkTheme}>
        <BrowserRouter>
            <Route path="/" exact component={RacesTabs}/>
            <Route path={"/map/:id"} exact component={RaceMap}/>
        </BrowserRouter>
    </MuiThemeProvider>
}

export default App;






